import { FeaturedNavigation } from 'src/js/components/featured-navigation/featured-navigation'
import { AccordeonButton } from '../components/accordeon'
import { AccordeonComponent } from '../components/accordeon/accordeon'
import { BackToTopButton } from '../components/back-to-top-button'
import { BodyElement } from '../components/body-element/body-element'
import { HorizontalProductCard } from '../components/cards/product-card/horizontal-product-card'
import { ProductCard } from '../components/cards/product-card/product-card'
import { ColorSwatches } from '../components/cards/product-card/product-card-color-swatches'
import { ProductMediaTabs } from '../components/cards/product-card/product-card-media-tabs'
import { VerticalProductCard } from '../components/cards/product-card/vertical-product-card'
import {
  CarouselButton,
  CarouselComponent,
  CarouselDots,
  CarouselPlayButton,
  CarouselProgress,
} from '../components/carousel'
import { CartCount } from '../components/cart-count'
import { CartNotificationPopup } from '../components/cart-notification'
import {
  ClipboardButton,
  ClipboardButtonTooltip,
} from '../components/clipboard-button'
import { CollapsedTags } from '../components/collapsed-tags'
import { ArticleTags } from '../components/cards/article-card'
import { CountdownTimer } from '../components/countdown-timer'
import { DeferredMedia } from '../components/deffered-media'
import {
  DropdownOpener,
  FloatElement,
  FloatElementBtn,
  TooltipTrigger,
} from '../components/float-element'
import { FreeShippingBar } from '../components/free-shipping-bar'
import { PasswordField, SearchField } from '../components/inputs'
import { LocalizationSelector } from '../components/localization-selector'
import { MaxLinesComponent } from '../components/max-lines-truncate'
import { ModalButton } from '../components/modal'
import { ModalComponent } from '../components/modal/modal'
import { NotificationComponent } from '../components/notification'
import {
  PaginationInfiniteScroll,
  PaginationLink,
  PaginationLoadButton,
} from '../components/pagination'
import { PaginationComponent } from '../components/pagination/pagination'
import { QuantityBtn } from '../components/quantity-input'
import { QuantityComponent } from '../components/quantity-input/quantity'
import { ShapeSwatch } from '../components/shape-swatch'
import { ShareComponent, ShareWrapper } from '../components/share'
import { SidebarButton } from '../components/sidebar'
import { SidebarComponent } from '../components/sidebar/sidebar'
import { StickyCartButton } from '../components/sticky-cart-button'
import { TabWithDynamicHeight } from '../components/tabs'
import { TabComponent } from '../components/tabs/tab'
import { TabsComponent } from '../components/tabs/tabs'
import { BeforeAfterImages } from '../sections/before-after-images'
import {
  CartAppBlock,
  CartButtonsBlock,
  CartCountdownBlock,
  CartFreeShippingBarBlock,
  CartInCartBannerBlock,
  CartItem,
  CartItemsBlock,
  CartNote,
  CartOrderNotesBlock,
  CartRelatedProducts,
  CartRelatedProductsBlock,
  CartRemoveButton,
  CartSubtotalBlock,
} from '../sections/cart'
import {
  CartDrawer,
  CartDrawerButtonsBlock,
  CartDrawerFooter,
  CartDrawerFreeShippingBarBlock,
  CartDrawerHeader,
  CartDrawerInCartBannerBlock,
  CartDrawerItemsBlock,
  CartDrawerRelatedProducts,
  CartDrawerRelatedProductsBlock,
  CartDrawerTimerBlock,
} from '../sections/cart-drawer'
import { CartPage } from '../sections/cart/cart'
import {
  ColumnSwitcher,
  FilterRemoveBtn,
  FiltersSubmitBtn,
  ListBtn,
  ListComponent,
  PriceRange,
  ShopActiveFilters,
  ShopComponent,
  SidebarFiltersDesktop,
  SidebarFiltersMobile,
  SidebarFiltersStickyMobileButton,
} from '../sections/collection-page'
import { SortList } from '../sections/collection-page/sort-list'
import {
  AddressesComponent,
  CountrySelector,
  LoginComponent,
  RegisterComponent,
} from '../sections/customer'
import { FaqSection } from '../sections/faq'
import {
  DrawerMenu,
  DrawerMenuPage,
  DrawerMenuPageLink,
  HeaderComponent,
} from '../sections/header'
import { HotspotsComponent, HotspotsFloatElement } from '../sections/hotspots'
import { LookbookComponent, LookbookModal } from '../sections/lookbook'
import { StoreLocator } from '../sections/map'
import { MapComponent } from '../sections/map/map-component'
import { PasswordModal, PasswordModalButton } from '../sections/password-page'
import {
  PopupAgeVerifier,
  PopupCookie,
  PopupPromo,
  PopupSignup,
} from '../sections/popups'
import {
  ColorSwatchesPicker,
  PickupAvailability,
  ProductBlock,
  ProductContent,
  ProductDetails,
  ProductForm,
  ProductFormButton,
  ProductInformationDrawer,
  ProductMedia,
  ProductMediaCarousel,
  ProductModal,
  ProductModalButton,
  ProductRelatedBlock,
  RecipientForm,
  VariantPicker,
  ZoomCursor,
} from '../sections/product'
import { ProductRecommendations } from '../sections/product-recommendations'
import { ProductModalImageWrap } from '../sections/product/product-modal-image-wrap'
import { ProductModel } from '../sections/product/product-model'
import { QuickView } from '../sections/product/quick-view'
import { RecentlyViewed } from '../sections/recently-viewed'
import { ScrollingText, ScrollingTextLine } from '../sections/scrolling-text'
import {
  SearchSidebar,
  SearchSidebarFormWrapper,
} from '../sections/search-drawer'
import { VideoBanner } from '../sections/video-banner'
import { registerComponent } from './utils'
import { ImageSlider } from 'src/js/components/image-slider/image-slider'
import { CloseCursor } from 'src/js/components/close-cursor/close-cursor'
import { QuoteComponent } from 'src/js/components/quote/quote'
import { TestimonialsComponent } from '../components/testimonials'
import { LazyVideo } from '../components/body-element/lazy-video'

const components = [
  LazyVideo,
  LoginComponent,
  RegisterComponent,
  BackToTopButton,
  StickyCartButton,
  QuantityComponent,
  QuantityBtn,
  LocalizationSelector,
  NotificationComponent,
  TabsComponent,
  TabComponent,
  ListComponent,
  ListBtn,
  FloatElement,
  HotspotsFloatElement,
  FloatElementBtn,
  DropdownOpener,
  TooltipTrigger,
  FaqSection,
  AccordeonComponent,
  AccordeonButton,
  ProductMediaTabs,
  ColorSwatches,
  ModalComponent,
  PasswordModal,
  CartNotificationPopup,
  ModalButton,
  PasswordModalButton,
  SidebarButton,
  SidebarComponent,
  SearchSidebar,
  QuickView,
  CarouselComponent,
  CarouselPlayButton,
  CarouselDots,
  CarouselButton,
  CarouselProgress,
  HeaderComponent,
  DrawerMenu,
  DrawerMenuPage,
  DrawerMenuPageLink,
  PaginationComponent,
  PaginationLoadButton,
  PaginationLink,
  PaginationInfiniteScroll,
  DeferredMedia,
  PickupAvailability,
  ProductForm,
  ProductFormButton,
  ProductDetails,
  ProductBlock,
  ProductModel,
  CartItem,
  CartPage,
  CartDrawer,
  FreeShippingBar,
  ProductContent,
  ProductMedia,
  ProductMediaCarousel,
  VariantPicker,
  ColorSwatchesPicker,
  ProductModal,
  ProductModalImageWrap,
  ProductModalButton,
  ProductRecommendations,
  ProductRelatedBlock,
  RecentlyViewed,
  SearchSidebarFormWrapper,
  CartRemoveButton,
  ClipboardButton,
  ClipboardButtonTooltip,
  ProductCard,
  HorizontalProductCard,
  VerticalProductCard,
  MaxLinesComponent,
  CountrySelector,
  SearchField,
  PasswordField,
  ZoomCursor,
  ShopComponent,
  ShopActiveFilters,
  SidebarFiltersDesktop,
  SidebarFiltersMobile,
  FilterRemoveBtn,
  SortList,
  PriceRange,
  ColumnSwitcher,
  FiltersSubmitBtn,
  BeforeAfterImages,
  CountdownTimer,
  ProductInformationDrawer,
  SidebarFiltersStickyMobileButton,
  RecipientForm,
  ShapeSwatch,
  AddressesComponent,
  TabWithDynamicHeight,
  VideoBanner,
  CartDrawerItemsBlock,
  CartDrawerInCartBannerBlock,
  CartDrawerRelatedProducts,
  CartDrawerRelatedProductsBlock,
  CartDrawerTimerBlock,
  CartDrawerHeader,
  CartDrawerFooter,
  CartItemsBlock,
  CartButtonsBlock,
  CartCountdownBlock,
  CartRelatedProductsBlock,
  CartOrderNotesBlock,
  CartNote,
  CartAppBlock,
  CartSubtotalBlock,
  CartInCartBannerBlock,
  CartFreeShippingBarBlock,
  CartCount,
  CartDrawerFreeShippingBarBlock,
  CartDrawerButtonsBlock,
  CartRelatedProducts,
  ShareWrapper,
  ShareComponent,
  ScrollingText,
  ScrollingTextLine,
  HotspotsComponent,
  CollapsedTags,
  ArticleTags,
  PopupAgeVerifier,
  PopupCookie,
  PopupPromo,
  PopupSignup,
  LookbookComponent,
  LookbookModal,
  MapComponent,
  StoreLocator,
  BodyElement,
  FeaturedNavigation,
  ImageSlider,
  CloseCursor,
  QuoteComponent,
  TestimonialsComponent,
]

// @ts-expect-error
window.recentlyViewed = RecentlyViewed

export const defineComponents = (): void => {
  components.forEach(registerComponent)
}
